export type AckDocumentStatus = 'not_opened' | 'opened' | 'acknowledged';

export interface AckDocumentCounters {
  assigned: number,
  notOpened: number,
  /** Открыли PDF, но не подтвердили */
  opened: number,
  acknowledged: number,
}

export interface AckDocumentTag {
  id: string,
  name: string,
  color?: string | null,
}

/** Неизвестный бэку критерий приходит только с type и title */
export interface AckDocumentCriterion {
  type: string,
  title?: string,
  tags?: AckDocumentTag[],
}

export interface AckDocumentFile {
  id: string,
  url: string,
  name: string,
  /** В байтах */
  size: number,
}

export interface AckDocument {
  id: string,
  title: string,
  createdAt: string,
  createdBy: { id: string, fullName: string } | null,
  criteria: AckDocumentCriterion[],
  counters: AckDocumentCounters,
  /** Только в ответах get и create */
  file?: AckDocumentFile,
  /**
   * Только на фронте: назначения ещё в очереди, а счётчики взяты из ответа create
   * (бэк считает их по аудитории). См. withCreatedCounters в requests.ts
   */
  countersPending?: boolean,
}

export interface AckDocumentAssignment {
  user: {
    id: string,
    fullName: string,
    avatarId: string | null,
    tags: AckDocumentTag[],
  },
  status: AckDocumentStatus,
  statusLabel: string,
  assignedAt: string,
  openedAt: string | null,
  acknowledgedAt: string | null,
}

export interface AckDocumentPager {
  currentPage: number,
  totalPages: number,
  totalItems: number,
}

export interface AckDocumentResult<T> {
  data?: T,
  error?: string,
  /** Ошибки валидации полей из result.errors.fields */
  fields?: Record<string, string>,
  /** HTTP-статус ошибки: 404 — фича выключена или документ удалён */
  status?: number,
}

export interface AckDocumentCreatePayload {
  title: string,
  fileId: string,
  /** [] — все участники */
  criteria: { type: 'position_tags', tagIds: string[] }[],
}

export interface AckDocumentAssignmentsQuery {
  page: number,
  count: number,
  status: AckDocumentStatus | '',
  search: string,
}

export const ACK_DOCUMENTS_SETTING_CODE = 'ack_documents.enabled';

export const ACK_DOCUMENT_MAX_FILE_SIZE = 20 * 1024 * 1024;

/** Только с context=ackDocument бэк проверяет, что файл — PDF до 20 МБ */
export const ACK_DOCUMENT_UPLOAD = {
  context: 'ackDocument',
  code: 'ack_document',
  glType: 'ackDocument',
};

export const ACK_DOCUMENTS_ROUTE = 'ack-documents';
export const ACK_DOCUMENT_ROUTE = 'ack-document';

export const ACK_DOCUMENT_STATUSES: AckDocumentStatus[] = ['not_opened', 'opened', 'acknowledged'];

export const ACK_DOCUMENT_ASSIGNMENTS_PAGE_SIZE = 20;
